// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DaysReading_wrapper__32ZFJ","panel":"DaysReading_panel__35i2u","inner":"DaysReading_inner__3O7FT","day":"DaysReading_day__21dLr","dayColor":"DaysReading_dayColor__qhhvc"};